import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { Row, Col, Image, Card } from "react-bootstrap";
import _ from 'lodash';
import { toast } from "react-toastify";
import { formatName } from "src/legacy/services/report.service.js";
import DefaultUserProfileImage from "src/legacy/images/default_user_profile_background.png";
import styles from './styles.module.scss';
import InfiniteScroll from 'react-infinite-scroller';
import dateformat from 'dateformat';
import buildUrl from 'build-url-ts';
import LoadingMessage from 'src/legacy/components/LoadingMessage';
import { localizedStrings } from 'src/localization/index.jsx';
import Toast from 'src/components/toast';
import Text from 'src/components/text';


class UserManagementListView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired
  }
  constructor(props) {
    super(props);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonLoading = this.localizedCommons.loading;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedUserManagement = this.localizedSettings.account.user_management;
    this.localizedInviteUser = this.localizedUserManagement.card;

    this.state = {
      query: "",
      filter: { name: this.localizedInviteUser.filters.all, value: "all" },
      updatedUser: ""
    }

    this._loadMoreUsers = this._loadMoreUsers.bind(this);
    this._handleUserActivationClick = this._handleUserActivationClick.bind(this);
    this._handleDeleteClick = this._handleDeleteClick.bind(this);
    this._handleResendInvitation = this._handleResendInvitation.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { updatedUser } = this.state;
    if (updatedUser) {
      const prevUser = this.props.users.find(user => user.id === updatedUser);
      const nextUser = nextProps.users.find(user => user.id === updatedUser);
      if (!_.isEqual(prevUser, nextUser)) {

      toast(
        <Toast.Sucess
        message={localizedStrings.formatString(this.localizedInviteUser.toast.update, {
          status: nextUser.enabled ? this.localizedCommons.activated : this.localizedCommons.deactivated
        })}
        />,
        {
        autoClose: 3000,
        }
      );
      this.setState({ updatedUser: "" });
      }
    }
  }

  _handleUserActivationClick(user, event) {
    event.stopPropagation();

    let updatedUser = {
      id: user.id,
      email: user.email,
      admin: user.admin,
      enabled: !user.enabled,
    };

    this.setState({
      updatedUser: updatedUser.id
    }, () => {
      this.props.updateUserActivation(updatedUser);
    });
  }

  _handleUserClick(user) {
    this.props.selectUser(user);
    this.props.hideSettingsSideMenu();

    var queryParams = {};
    var query = this.props.location.query["query"] || ''
    if (query) {
      queryParams['query'] = query;
    }

    var path = buildUrl(null, {
      path: `/settings/user-management/user/${user.id}`,
      queryParams: queryParams
    });

    this.props.navigate(path);
  }

  _handleResendInvitation(id) {
    Promise.resolve(this.props.resendInvitation(id)).then(() => {
      toast(
        <Toast.Sucess
          message={this.localizedInviteUser.toast.resend_invite}
        />,
        {
          autoClose: 3000,
        }
      );
    });
  }

  _handleDeleteClick(id) {
    this.props.deleteInvitation(id).then(() => {
      toast(
        <Toast.Sucess
          message={this.localizedInviteUser.toast.delete}
        />,
        {
          autoClose: 3000,
        }
      );
    });
  }

  _loadMoreUsers() {

    var current = this.props.currentPage;

    if (this.props.loading) {
      return false;
    }

    var query = this.props.location.query["query"] || '';
    let filter = this.props.params.filter || "all";

    this.props.fetchUserManagementList(current + 1, query, filter);
  }


  _handleUserGroupClick(userGroup) {
    this.props.fetchUserGroup(userGroup.id);
    this.props.hideSettingsSideMenu();

    var queryParams = {};
    var query = this.props.location.query["query"] || "";
    if (query) {
      queryParams["query"] = query;
    }

    var path = buildUrl(null, {
      path: `/settings/user-management/group/${userGroup.id}`,
      queryParams: queryParams,
    });

    this.props.navigate(path);

  }

  render() {
    return (
      <InfiniteScroll
        pageStart={0}
        initialLoad={false}
        hasMore={this.props.currentPage < this.props.totalPages}
        loadMore={() => { this._loadMoreUsers() }}
        useWindow={false}
      >
        <div className={styles.children}>
          {this._renderUsers()}
        </div>
      </InfiniteScroll>

    );
  }

  _renderUsers() {
    if (
      (!this.props.users || this.props.users.length == 0) &&
      this.props.loading &&
      this.props.currentPage == 0
    ) {
      return this._renderLoading();
    }

    var rows = new Array();

    let filter = this.state.filter.value;

    this.props.users.forEach((user, index) => {
      if (user.entityType == "user" &&
        (filter === "all" || filter === "users")
      ) {
        let icon = _.get(user, "icon.thumbnail");
        if (!icon) {
          icon = DefaultUserProfileImage;
        }

        rows.push(
          <Col md={4} className={styles.column} key={user.id}>
            <div
              onClick={() => {
                this._handleUserClick(user);
              }}
              className={cx(styles.user)}
            >
              <div className={styles.userIconWrapper}>
                <div
                  className={cx(styles.active, {
                    [styles.deactive]: !user.enabled,
                  })}
                ></div>
                <Image className={styles.icon} src={icon} />
              </div>
              <div className={styles.userDetails}>
                <div className={styles.name}>
                  <Text lines={1} className={styles.userName} text={formatName(user)} />
                </div>
                <div className={styles.email}>
                  <Text lines={1} text={user.email || ""} />
                </div>
                <div className={styles.date}>
                  {this.localizedCommons.created_on}:{" "}
                  {dateformat(user.createdDate, "dd mmm yyyy") || ""}
                </div>
                <div
                  className={cx(styles.action, {
                    [styles.deactiveAction]: user.enabled,
                    [styles.disabled]: this.props.updating
                  })}
                  onClick={(e) => {
                    if (!this.props.updating) {
                      this._handleUserActivationClick(user, e);
                    }
                  }}
                >
                  {user.enabled ? this.localizedInviteUser.actions.deactivate : this.localizedInviteUser.actions.activate}
                </div>
                <div className={styles.role}>
                {user.admin ? this.localizedCommons.roles.admin : user.role === "Starter Licence" ? this.localizedCommons.roles.starter_licence: user.role}
                </div>
              </div>
            </div>
          </Col>
        );
      }
      if (user.entityType == "user_group" &&
        (filter === "all" || filter === "user_groups")) {
        let iconLength = _.size(user.icons);
        
        rows.push(
          <Col md={4} className={styles.column} key={user.id}>
            <div
              onClick={() => {
                this._handleUserGroupClick(user);
              }}
              className={cx(styles.user)}
            >
              <div className={styles.userGroupIconWrapper}>
                {iconLength === 1 && this._renderFirstUserIcon(user)}
                {iconLength >= 2 && this._renderSecondUserIcon(user)}
                {iconLength === 0 && this._renderDefaultIcon()}
              </div>
              <div className={styles.userGroupDetails}>
                <div className={styles.name}>
                  <Text lines={1} text={user.name} />
                </div>
                <div className={styles.email}>
                  {user.usersCount} {user.usersCount == 1 ? this.localizedCommons.user : this.localizedCommons.users}
                </div>
                <div className={styles.date}>
                  {this.localizedCommons.created_on}: {dateformat(user.createdDate, "dd mmm yyyy")}
                </div>
                <div className={cx(styles.action)}>
                  <i className={cx("paperflite-add", styles.add)} aria-hidden="true" /> {this.localizedInviteUser.actions.add_users}
                </div>
              </div>
            </div>
          </Col>
        );
      }
      if (
        user.entityType == "invitation" &&
        _.size(user.email) > 0 &&
        (filter === "all" || filter === "invitations")
      ) {
        if (_.get(user,"accepted")) {
          return;
        }
        let firstCharacter = user.email.charAt(0);
      
        rows.push(
          <Col md={4} className={styles.column} key={user.id}>
            <div className={cx(styles.user)}>
              <div className={styles.userIconWrapper}>
                <div className={cx(styles.active, styles.pending)}></div>
                <div className={styles.invitation}>
                  {firstCharacter.toUpperCase()}
                </div>
              </div>
              <div className={styles.userDetails}>
                <div className={styles.name}>
                  <Text lines={1} text={user.email} />
                </div>
                <div className={styles.date}>
                  {this.localizedInviteUser.invite_sent_on}: {dateformat(user.invitedDate, "dd mmm yyyy")}
                </div>
                <div
                  className={cx(styles.action)}
                  onClick={() => this._handleResendInvitation(user.id)}
                >
                  {this.localizedInviteUser.actions.resend_invite}
                </div>
                <div
                  className={styles.delete}
                  onClick={() => this._handleDeleteClick(user.id)}
                >
                  <span className="paperflite-delete" />
                </div>
              </div>
            </div>
          </Col>
        );
      }
    });

    return rows;
  }

  _renderFirstUserIcon(user) {
    return [
      <Image
        key={`${user.id}-icon`}
        className={styles.userGroupIcon}
        src={user.icons[0].thumbnail}
        circle
      />,
      <div key={`${user.id}-iconlayer1`} className={styles.defaultImage2}>
        <div className={cx(styles.userGroupCount1, styles.layer3)}></div>
      </div>,
      <div key={`${user.id}-iconlayer2`} className={styles.userGroupContainer}>
        <div className={cx(styles.userGroupCount1, styles.layer3)}></div>
      </div>,
    ];
  }

  _renderSecondUserIcon(user) {
    return [
      <Image
        key={`${user.id}-icon2`}
        className={styles.userGroupIcon}
        src={user.icons[0].thumbnail}
        circle
      />,
      <Image
        key={`${user.id}-icon2layer1`}
        className={cx(styles.userGroupIcon, styles.layer1)}
        src={user.icons[1].thumbnail}
        circle
      />,
      <div key={`${user.id}-icon2layer2`}>
        <div className={styles.userGroupContainer}>
          <div className={cx(styles.userGroupCount1, styles.layer3)}>
            {user.usersCount > 2 ? `+${user.usersCount - 2}` : ""}
          </div>
        </div>
      </div>,
    ];
  }

  _renderDefaultIcon() {
    return [
      <div className={styles.defaultImage1}>
      <div className={cx(styles.userGroupCount1, styles.layer3)}></div>
      </div>,
      <div className={styles.defaultImage2}>
      <div className={cx(styles.userGroupCount1, styles.layer3)}></div>
      </div>
      ,
      <div className={styles.userGroupContainer}>
      <div className={cx(styles.userGroupCount1, styles.layer3)}> 0</div>
      </div>
      ,
    ];
  }

  _renderLoading() {
    return (
      <div className={styles.loading}>
        <LoadingMessage
          className={styles.loadingInner}
          message={`${this.localizedCommonLoading.users}`}
          visible={true} />
      </div>
    )
  }

}

UserManagementListView.contextTypes = {
  store: PropTypes.object
}

export default UserManagementListView;    